"use client";

import React, { useCallback, useContext } from "react";

import ChipBase from "@mui/material/Chip";
import { ChipProps as ChipBaseProps } from "@mui/material/Chip/Chip.d";

import { AccessibilityKeys } from "~/constants/accessibility";
import { AccessibilityLabelsContext } from "~/context/accessibility-label/context";
import { replaceCmsVariables } from "~/helpers/replace-cms-variables";

export interface ChipProps extends Omit<ChipBaseProps, "onDelete"> {
  value?: string;
  onDelete?: (value?: string) => void;
  handleFilterChipA11yLabel?: (el: React.ReactNode) => void;
}

export const Chip: React.FC<ChipProps> = ({ value, onDelete, ...props }) => {
  const { handleFilterChipA11yLabel, label, ...restProps } = props;
  const handleDelete = useCallback(() => {
    if (onDelete) {
      handleFilterChipA11yLabel?.(label);
      onDelete(value);
    }
  }, [label, onDelete, handleFilterChipA11yLabel, value]);

  const accessibilityLabelsContext = useContext(AccessibilityLabelsContext);

  const ariaLabelValue = replaceCmsVariables(
    accessibilityLabelsContext?.[AccessibilityKeys.FilterChipOn],
    {
      chip_name: props?.label?.toString(),
    },
  );

  return (
    <ChipBase
      {...restProps}
      label={label}
      key={props.key}
      onClick={handleDelete}
      onDelete={handleDelete}
      aria-label={ariaLabelValue || undefined}
    />
  );
};
